export default "__VITE_ASSET__BOE7_bye__"